/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CopyCommentEmbedCodeContainer_settings = {
    readonly embeddedComments: {
        readonly allowReplies: boolean | null;
    } | null;
    readonly reaction: {
        readonly label: string;
    };
    readonly " $refType": "CopyCommentEmbedCodeContainer_settings";
};
export type CopyCommentEmbedCodeContainer_settings$data = CopyCommentEmbedCodeContainer_settings;
export type CopyCommentEmbedCodeContainer_settings$key = {
    readonly " $data"?: CopyCommentEmbedCodeContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"CopyCommentEmbedCodeContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyCommentEmbedCodeContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "EmbeddedCommentsConfiguration",
            "kind": "LinkedField",
            "name": "embeddedComments",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowReplies",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '1434ddaf0485eb484339b03d7cddd55d';
export default node;
